// HOME 
import hero from './imgs/home-hero.png';
import heroVideoPoster from './imgs/video-loader-image.png';
import slide1 from './imgs/home-slide1.png';
import slide2 from './imgs/home-slide2.png';
import slide3 from './imgs/home-slide3.png';
import slide4 from './imgs/home-slide4.png';
import slide5 from './imgs/home-slide5.png';
import slide6 from './imgs/home-slide6.png';
import slide7 from './imgs/home-slide7.png';
import slide8 from './imgs/home-slide8.png';
import slide9 from './imgs/home-slide9.png';
import desktopBanner from './imgs/home-hero-desktop.png';
import mobileBanner from './imgs/home-hero-mobile.png';
import desktopCollage from './imgs/home-page-collage-desktop.png';
import mobileCollage from './imgs/home-page-collage-mobile.png';
import registerCard1 from './imgs/register-card-1.png';
import registerCard2 from './imgs/register-card-2.png';
import registerCard3 from './imgs/register-card-3.png';
import registerCard4 from './imgs/register-card-4.png';
import registerCard5 from './imgs/register-card-5.png';
import registerCard6 from './imgs/register-card-6.png';
import greenBackground from './imgs/green_background.jpg';
//VOLUNTEER
import volunteerBannerDesktop from './imgs/volunteer-banner-desktop.png';
import volunteerBannerMobile from './imgs/volunteer-banner-mobile.png';
import volunteerInfo from './imgs/volunteer-info.jpg';
import volunteerCards1 from './imgs/volunteer-cards-1.png';
import volunteerCards2 from './imgs/volunteer-cards-2.png';
import volunteerCards3 from './imgs/volunteer-cards-3.png';
import volunteerCollage1 from './imgs/volunteer-collage-1.png';
import volunteerCollage2 from './imgs/volunteer-collage-2.png';
import volunteerCollage3 from './imgs/volunteer-collage-3.png';
import volunteerCollage4 from './imgs/volunteer-collage-4.png';

// STATS
import stats1 from './imgs/stats-1.png';
import stats2 from './imgs/stats-2.png';
import stats3 from './imgs/stats-3.png';
import stats4 from './imgs/stats-4.png';

// STARTUPS
import startupBannerDesktop from './imgs/startups-banner-desktop.png';
import startupBannerMobile from './imgs/startups-banner-mobile.png';
import brandExposure from './imgs/brand-exposure.png';
import immersiveLearning from './imgs/immersive-learning.png';
import smartMoney from './imgs/smart-money.png';
import exclusiveNetworking from './imgs/exclusive-networking.png';

// SPEAKERS
import speakersBannerDesktop from './imgs/speakers-banner-desktop.png';
import speakersBannerMobile from './imgs/speakers-banner-mobile.png';
// AGENDA
import agendaBannerDesktop from './imgs/agenda-banner-desktop.png';
import agendaBannerMobile from './imgs/agenda-banner-mobile.png';
// PARTNERS
import partnersBannerDesktop from './imgs/partners-banner-desktop.png';
import partnersBannerMobile from './imgs/partners-banner-mobile.png';
// PRESS
import pressBannerDesktop from './imgs/press-banner-desktop.jpg';
import pressBannerMobile from './imgs/press-banner-mobile.jpg';
import pressInfo from './imgs/press-info.png';
// VENTURE NURTURING
import ventureBannerDesktop from './imgs/venture-nurturing-banner-desktop.png';
import ventureBannerMobile from './imgs/venture-nurturing-banner-mobile.png';
import ventureInfo from './imgs/venture-nurturing-info.png';
//  VENUE
import venueInfo from './imgs/venue-info.png';
import venue from './imgs/venue.jpg';
import venueBannerDesktop from './imgs/venue-banner-desktop.jpg';
import venueBannerMobile from './imgs/venue-banner-mobile.jpg';
import venueLocation from './imgs/venue-location.png';
// REGISTER
import registerBannerDesktop from './imgs/register-banner-desktop.png';
import registerBannerMobile from './imgs/register-banner-mobile.png';
//TOPINNOVATORS
import topInovatorsDesktop from './imgs/top-inovators-desktop.png';
// ICONS
import googleMaps from './imgs/icon-google-maps.png';
import waze from './imgs/icon-waze.png';
import google from './imgs/google-icon.png';
import outlook from './imgs/outlook-icon.png';
import apple from './imgs/apple-icon.png';

export const imgs = {
   home: {
      heroVideoPoster,
      greenBackground,
      hero,
      slide1,
      slide2,
      slide3,
      slide4,
      slide5,
      slide6,
      slide7,
      slide8,
      slide9,
      desktopBanner,
      mobileBanner,
      desktopCollage,
      mobileCollage,
      registerCard1,
      registerCard2,
      registerCard3,
      registerCard4,
      registerCard5,
      registerCard6,
   },
   stats:{
      stats1,
      stats2,
      stats3,
      stats4,
   },
   volunteer: {
      volunteerBannerDesktop,
      volunteerBannerMobile,
      volunteerCards1,
      volunteerCards2,
      volunteerCards3,
      volunteerCollage1,
      volunteerCollage2,
      volunteerCollage3,
      volunteerCollage4,
      volunteerInfo,
   },
   startups: {
      exclusiveNetworking,
      immersiveLearning,
      smartMoney,
      brandExposure,
      startupBannerDesktop,
      startupBannerMobile,
   },
   speakers: {
      speakersBannerDesktop,
      speakersBannerMobile,
   },
   agenda: {
      agendaBannerDesktop,
      agendaBannerMobile,
   },
   partners: {
      partnersBannerDesktop,
      partnersBannerMobile,
   },
   press: {
      pressBannerDesktop,
      pressBannerMobile,
      pressInfo,
   },
   ventureNurturing: {
      ventureBannerDesktop,
      ventureBannerMobile,
      ventureInfo,
   },
   venue: {
      venueInfo,
      venue,
      venueBannerDesktop,
      venueBannerMobile,
      venueLocation,
   },
   register: {
      registerBannerDesktop,
      registerBannerMobile,
   },
   topInovators: {
      topInovatorsDesktop,
   },
   icons: {
      googleMaps,
      waze,
      google,
      outlook,
      apple,
   },
}